import React, { Component } from 'react';
import './iamExUsActionRow.css';
import {writeActions} from '../../../utils/writeActions.json';

class IamExUsActionRow extends Component {

  state = {
    infoRowVisible: false
  };

  componentDidMount() {

  };

  render() {

    const resources = {
      Allow: [],
      AllowObjects: [],
      Deny: [],
      DenyObjects: [],
      objects: []
    };

    let rowClass = 'Neutral';

    const includesAction = action => {
      const regex = new RegExp(action.replace('*', '.*'));
      return regex.test(this.props.action);
    };

    [
      {
        array: this.props.user.InlinePolicies,
        policyType: 'Inline Policy'
      },
      {
        array: this.props.user.ManagedPolicies,
        policyType: 'Managed Policy'
      },
      {
        array: this.props.user.InlineGroupPolicies,
        policyType: 'Inline Group Policy'
      },
      {
        array: this.props.user.ManagedGroupPolicies,
        policyType: 'Managed Group Policy'
      },
      {
        array: this.props.user.AssumeRoleInlinePolicies,
        policyType: 'Inline Role Policy'
      },
      {
        array: this.props.user.AssumeRoleManagedPolicies,
        policyType: 'Managed Role Policy'
      }
    ].forEach(policyArray => {
      const policyType = policyArray.policyType;
      policyArray.array.forEach(policy => {
        policy.PolicyDocument.Statement.forEach(statement => {
          if ((statement.Action && statement.Action.find(includesAction)) || (statement.NotAction && !statement.NotAction.find(includesAction))) {
            if (!policy.RoleName || policy.AccountId === this.props.user.AccountId) {
              resources[statement.Effect].push(...statement.Resource);
              resources.objects.push({
                policyType,
                policyName: policy.PolicyName,
                effect: statement.Effect,
                resource: statement.Resource,
                groupName: policy.GroupName,
                roleName: policy.RoleName
              });
            };
          };
        });
      });
    });

    if (resources.Deny.includes('*')) rowClass = 'DenyAll';
    else if (resources.Deny.length > 0) rowClass = 'DenySome';
    else if (resources.Allow.includes('*')) rowClass = 'AllowAll';
    else if (resources.Allow.length > 0) rowClass = 'AllowSome';

    const actionType = writeActions.includes(this.props.action) ? 'Write' : 'Read';

    return rowClass !== 'Neutral' &&
    <React.Fragment>
      <tr onClick={this.toggleInfoRow} className={rowClass}>
        <td>
          {this.props.action.match(/(.+):/)[1]}
        </td>
        <td>
          {this.props.action.match(/:(.+)/)[1]}
        </td>
        <td>
          {actionType}
        </td>
        <td>
          {resources.Allow.join(', ')}
        </td>
        <td>
          {resources.Deny.join(', ')}
        </td>
      </tr>
      {this.state.infoRowVisible && resources.objects.map((object, index) => {
        return (
          <tr key={index}>
            <td></td>
            <td className={`PolicyInfo${object.effect}`} colSpan="4">
              {`${object.policyType} "${object.policyName}"${object.groupName ? ` from "${object.groupName}" group` : ''}${object.roleName ? ` from "${object.roleName}" role` : ''} - ${object.effect} on resources "${object.resource.join('", "')}".`}
            </td>
          </tr>
        );
      })}
    </React.Fragment>;
  };

  toggleInfoRow = () => {
    this.setState({infoRowVisible: !this.state.infoRowVisible});
  }

};

export default IamExUsActionRow;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExUsers/iamExUsContent/iamExUsActionRow/iamExUsActionRow.js